import React, { useEffect, useCallback, useState } from 'react';
import { useLocation, history } from 'umi';
import qs from 'qs';
import { useDispatch } from 'dva';
import { Box } from '@material-ui/core';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';
import request from '@/utils/request';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [tableData, setTableData] = useState({ data: [], total: 0 });
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const { depName, pageNum = '1', pageSize = '10', refreshTime } = query;
  const [listLoading, setListLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  // 查询事件处理
  const handleSearch = (newParam) => {
    console.log('newParam', newParam);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //获取列表
  const fetchDepList = useCallback(() => {
    setListLoading(true);
    const values = {
      pageNum,
      pageSize,
      depName: depName || null,
    };

    request('/coupon/dep/query/page', {
      method: 'POST',
      data: values,
    })
      .then((res) => {
        setTableData(res.data);
        setListLoading(false);
      })
      .catch(() => {
        setListLoading(false);
      });
  }, [dispatch, pageNum, pageSize, depName, refreshTime]);
  useEffect(() => {
    fetchDepList();
  }, [fetchDepList]);

  const handleClickDelete = (rowInfo) => {
    console.log('删除', rowInfo);
    if (rowInfo.count > 0) {
      setOpenDialog(false);
      return;
    }
    request('/coupon/dep/delete', {
      method: 'POST',
      data: {
        id: rowInfo.id,
      },
    }).then((res) => {
      if (res.code === 0) {
        setOpenDialog(false);
        fetchDepList();
      }
    });
  };

  const handleClickRow = (obj) => {
    history.push(obj);
  };

  return (
    <Box>
      <SearchGroup
        handleRestClick={handleRestClick}
        handleSearch={handleSearch}
        query={query}
      />
      <ResultList
        handlePageChange={handlePageChange}
        pageData={{ pageNum, pageSize }}
        tableData={tableData}
        listLoading={listLoading}
        handleClickDelete={handleClickDelete}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        handleClickRow={handleClickRow}
      />
    </Box>
  );
};
